export const ExternalDataProcessors = `
## 外部アプリケーションの利用目的
ONE CAREER CLOUD では、サービス向上および利用企業の皆様により適したサービスを提供するため、外部アプリケーションをWEBアプリ内に設置し、利用者の情報を利用者の端末等から外部に送信することがあります。

## 外部アプリケーションの種類と利用目的 
### Sentry
- 送信先事業者名：Functional Software, Inc.
- 送信される情報：利用企業識別子、利用企業に紐づく利用者識別子、利用企業名 等
- 弊社での利用目的：アプリケーションでエラーや障害が発生した時に、その内容を記録するため
- 送信先事業者での利用目的：エラーレポートと問題解析のため

### Google Analytics
- 送信先事業者名：Google LLC
- 送信される情報：利用企業識別子、利用企業に紐づく利用者識別子、利用企業名、端末に関する情報 等
- 弊社での利用目的：ウェブサイトのトラフィックとユーザーの行動を追跡し、分析するため
- 送信先事業者での利用目的：利用者による閲覧の傾向や履歴の分析のため

## 本件に関するお問い合わせ
〒150-0031  
東京都渋谷区桜丘町20-1  
渋谷インフォスタワー16階

本ページに関するお問い合わせは<a href="https://support.onecareer.jp/hc/ja/requests/new" target="_blank">こちら</a>

令和5年7月13日制定
`;
